/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-patient.reducer';

export const TumorBoardPatientDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardPatientEntity = useAppSelector(state => state.tumorBoardPatient.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardPatientDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.detail.title">TumorBoardPatient</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardPatientEntity.id}</dd>
          <dt>
            <span id="addedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.addedAt">Added At</Translate>
            </span>
            <UncontrolledTooltip target="addedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.addedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.addedAt}</dd>
          <dt>
            <span id="completedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.completedAt">Completed At</Translate>
            </span>
            <UncontrolledTooltip target="completedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.completedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.completedAt}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.status">Status</Translate>
            </span>
            <UncontrolledTooltip target="status">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.status" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardPatientEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.board">Board</Translate>
          </dt>
          <dd>{tumorBoardPatientEntity.board ? tumorBoardPatientEntity.board.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.patient">Patient</Translate>
          </dt>
          <dd>{tumorBoardPatientEntity.patient ? tumorBoardPatientEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.addedBy">Added By</Translate>
          </dt>
          <dd>{tumorBoardPatientEntity.addedBy ? tumorBoardPatientEntity.addedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.handedOverBy">Handed Over By</Translate>
          </dt>
          <dd>{tumorBoardPatientEntity.handedOverBy ? tumorBoardPatientEntity.handedOverBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-patient" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-patient/${tumorBoardPatientEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardPatientDetail;
